import { Tooltip, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { useRef, useState } from 'react';

export const TruncatedText = ({ children, sx }: { children: string; sx?: SxProps<Theme> }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textReference = useRef<HTMLSpanElement>(null);

  const checkTruncation = () => {
    if (textReference.current) {
      setIsTruncated(textReference.current.scrollHeight > textReference.current.clientHeight);
    }
  };

  return (
    <Tooltip title={isTruncated ? children : ''} placement='bottom-start'>
      <Typography
        ref={textReference}
        onMouseEnter={checkTruncation}
        variant='caption'
        component='span'
        sx={{
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'normal',
          lineHeight: 1.4,
          ...sx,
        }}
      >
        {children}
      </Typography>
    </Tooltip>
  );
};
